import Request from ".";
import { Routes } from "../constant/api_url";

const getStockProductList = async (data) => {
  try {
    const result = await Request.post(Routes.GETSTOCKPRODUCTLIST, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const insertmember = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTMEMBER, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};
const getChapter = async () => {
  try {
    const result = await Request.get(Routes.ALLCHAPTER);
    return result;
  } catch (error) {
    throw error;
  }
};

const UpdateMemberStatus = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEMEMBERSTATUS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const InsertState = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTSTATE, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const UpdateMemberPost = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEMEMBERPOST, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const UpdateMeeting = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEMEETING, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const UpdateMember = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEMEMBER, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const userLogout = async (data) => {
  try {
    const result = await Request.get(Routes.USERLOGOUT + "/" + data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const GetMemberById = async (id) => {
  try {
    const result = await Request.get(Routes.GETMEMBERBYID + "?memberid=" + id);
    return result;
  } catch (error) {
    throw error;
  }
};

const GetMemberByChptId = async (id) => {
  try {
    const result = await Request.get(Routes.GETMEMBERBYCHPT + "/" + id);
    return result.data.data;
  } catch (error) {
    throw error;
  }
};
const GetMeetingById = async (id) => {
  try {
    const result = await Request.get(Routes.GETMEETINGBYID + "/" + id);
    return result.data[0];
  } catch (error) {
    throw error;
  }
};

const getState = async () => {
  try {
    const result = await Request.get(Routes.GETSTATE);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getCity = async (id) => {
  try {
    const result = await Request.get(Routes.GETCITY + "?stateid=" + id);
    return result.data;
  } catch (error) {
    throw error;
  }
};
const GetAllUserApi = async (id) => {
  try {
    const result = await Request.get(Routes.GETALLUSER);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const GetAllMemberApi = async (city_id, u_type) => {
  try {
    const result = await Request.get(Routes.GETALLMEMBER + "/" + city_id + "/" + u_type);
    return result.data;
  } catch (error) {
    throw error;
  }
};

// Active Privilege members — search + pagination, no city/chapter scoping
const getPrivilegeActiveMemberList = async (data) => {
  try {
    const result = await Request.post(Routes.GETPRIVILEGEACTIVEMEMBERLIST, data, {
      headers: {
        Accept: "application/json, */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const InsertMemberApi = async () => {
  try {
  } catch (error) { }
};

const getPollSelect = async (type, userType, cityId) => {
  try {
    const result = await Request.get(
      Routes.GETPOLLSELECT + "/" + type + "/" + userType + "/" + cityId
    );
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertpoll = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTPOLL, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const batchInsertPoll = async (data) => {
  try {
    const result = await Request.post(Routes.BATCHINSERTPOLL, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "multipart/form-data"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getPollByBatch = async (parent_p_id) => {
  try {
    const result = await Request.get(Routes.GETPOLLBYBATCH + "/" + parent_p_id);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getPollChildren = async (parent_p_id) => {
  try {
    const result = await Request.get(Routes.GETPOLLCHILDREN + "/" + parent_p_id);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updatePoll = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEPOLL, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};
const insertevent = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTEVENT, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertgreeting = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTGREETING, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};
const insertgallery = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTGALLERY, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getAllGallery = async () => {
  try {
    const result = await Request.get(Routes.GETALLGALLERY);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deleteGallery = async (g_id) => {
  try {
    const result = await Request.get(Routes.DELETEGALLERY + "/" + g_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getAllPoll = async (city_id, u_type, filters = {}) => {
  try {
    const params = new URLSearchParams();
    if (filters.page) params.append("page", filters.page);
    if (filters.limit) params.append("limit", filters.limit);
    if (filters.p_type !== undefined && filters.p_type !== 0) params.append("p_type", filters.p_type);
    if (filters.poll_status !== undefined && filters.poll_status !== 0) params.append("poll_status", filters.poll_status);
    if (filters.poll_send_status !== undefined && filters.poll_send_status !== null) params.append("poll_send_status", filters.poll_send_status);
    if (filters.search) params.append("search", filters.search);
    if (filters.sort_by) params.append("sort_by", filters.sort_by);
    if (filters.sort_order) params.append("sort_order", filters.sort_order);
    const queryString = params.toString();
    const url = Routes.GETALLPOLL + "/" + city_id + "/" + u_type + (queryString ? "?" + queryString : "");
    const result = await Request.get(url);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deletePoll = async (p_id) => {
  try {
    const result = await Request.get(Routes.DELETEPOLL + "/" + p_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getAllEventAnnou = async (city_id, u_type) => {
  try {
    const result = await Request.get(Routes.GETALLEVENTANNO + "/" + city_id + "/" + u_type);
    return result.data;
  } catch (error) {
    throw error;
  }
};
const getAllGreeting = async (city_id, u_type) => {
  try {
    const result = await Request.get(Routes.GETALLGREETING + "/" + city_id + "/" + u_type);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const EventAnnouDelete = async (e_id) => {
  try {
    const result = await Request.get(Routes.EVENTANNOUDELETE + "/" + e_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};
const getpollresult = async (p_id) => {
  try {
    const result = await Request.get(Routes.GETPOLLRESULT + "/" + p_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getAllCity = async () => {
  try {
    const result = await Request.get(Routes.GETALLCITY);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getAllState = async (id) => {
  try {
    const result = await Request.get(Routes.GETALLSTATE);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getAllCountry = async (id) => {
  try {
    const result = await Request.get(Routes.GETALLCOUNTRY);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertcity = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTCITY, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertcountry = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTCOUNTRY, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertlandmark = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTLANDMARK, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertmeeting = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTMEETING, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getAllLandmark = async (id) => {
  try {
    const result = await Request.get(Routes.GETALLLANDMARK);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const UpdateLandmarkStatus = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATELANDMARKSTATUS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const UpdateStateStatus = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATESTATESTATUS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const UpdateCityStatus = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATECITYSTATUS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getAllChapter = async () => {
  try {
    const result = await Request.get(Routes.GETALLCHAPTER);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getAllBusiness = async (ch_id, m_id) => {
  try {
    const result = await Request.get(Routes.GETALLBUSINESS + "/" + ch_id + "/" + m_id);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getAllBusinessV1 = async (data) => {
  try {
    const result = await Request.post(Routes.GETALLBUSINESSV1, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const UpdateBamount = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEBAMOUNT, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateState = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATESTATE, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};
const updatecity = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATECITY, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getCitySupportList = async (data) => {
  try {
    const result = await Request.post(Routes.GETCITYSUPPORTLIST, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const createCitySupportProfile = async (data) => {
  try {
    const result = await Request.post(Routes.CREATECITYSUPPORTPROFILE, data, {
      headers: {
        Accept: "application/json , */*"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateCitySupportProfile = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATECITYSUPPORTPROFILE, data, {
      headers: {
        Accept: "application/json , */*"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deleteCitySupportProfile = async (data) => {
  try {
    const result = await Request.delete(Routes.DELETECITYSUPPORTPROFILE, { data });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateCitySupportProfileStatus = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATECITYSUPPORTPROFILESTATUS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getCityEdDetails = async (data) => {
  try {
    const result = await Request.post(Routes.GETCITYEDDETAILS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const saveCityEdDetails = async (data) => {
  try {
    const result = await Request.post(Routes.SAVECITYEDDETAILS, data, {
      headers: {
        Accept: "application/json , */*",
        ...(data instanceof FormData ? {} : { "Content-Type": "application/json" })
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};
const updatelandmark = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATELANDMARK, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deleteBusiness = async (b_id) => {
  try {
    const result = await Request.get(Routes.DELETEBUSINESS + "/" + b_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getAllV2v = async (ch_id, m_id) => {
  try {
    const result = await Request.get(Routes.GETV2VLIST + "/" + ch_id + "/" + m_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getV2vV1 = async (data) => {
  try {
    const result = await Request.post(Routes.GETV2VLISTV1, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deleteV2v = async (v2v_id) => {
  try {
    const result = await Request.get(Routes.DELETEV2V + "/" + v2v_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getAllvisitor = async (ch_id, m_id) => {
  try {
    const result = await Request.get(Routes.GETVISITORBYID + "/" + ch_id + "/" + m_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getAllvisitorV1 = async (data) => {
  try {
    const result = await Request.post(Routes.GETVISITORV1, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deleteVisitorData = async (id) => {
  try {
    const result = await Request.get(Routes.DELETEVISITOR + "/" + id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getAllTestimonial = async (m_id) => {
  try {
    const result = await Request.get(Routes.GETTESTIMONIALLIST + "/" + m_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getAllTestimonialV1 = async (data) => {
  try {
    const result = await Request.post(Routes.GETTESTIMONIALLISTV1, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deleteTestimonialData = async (id) => {
  try {
    const result = await Request.get(Routes.DELETETESTIMONIAL + "/" + id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const deleteMeeting = async (m_id) => {
  try {
    const result = await Request.get(Routes.DELETEMEETING + "/" + m_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getAllReference = async (ch_id, m_id) => {
  try {
    const result = await Request.get(Routes.GETREFERENCELIST + "/" + ch_id + "/" + m_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getAllReferenceV1 = async (data) => {
  try {
    const result = await Request.post(Routes.GETREFERENCELISTV1, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deleteReference = async (r_id) => {
  try {
    const result = await Request.get(Routes.DELETEREFERENCE + "/" + r_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const deleteChapter = async (chpt_id, u_id) => {
  try {
    const result = await Request.get(Routes.DELETECHAPTER + "/" + chpt_id + "/" + u_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const resetMeetingMember = async (m_id) => {
  try {
    const result = await Request.get(Routes.RESETMEETINGMEMBER + "/" + m_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const GetStateById = async (id) => {
  try {
    const result = await Request.get(Routes.GETSTATEBYID + "/" + id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getSystemLogModules = async () => {
  try {
    const result = await Request.get(Routes.GETSYSTEMLOGMODULES);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getSystemLogs = async (data) => {
  try {
    const result = await Request.post(Routes.GETSYSTEMLOGS, data);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getAchievementPinsWithProgress = async (data) => {
  try {
    const result = await Request.post(Routes.GETACHIEVEMENTPINSWITHPROGRESS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });

    return result.data;
  } catch (error) {
    throw error;
  }
};

const getattendance = async (id) => {
  try {
    const result = await Request.get(Routes.GETATTENDANCE + "/" + id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const updateEventAnnouncement = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEEVENTANNOUNCEMENT, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getMemberAttendanceByChepter = async (data) => {
  try {
    const result = await Request.post(Routes.GETMEMBERATTENDANCEBYCHEPER, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getMemberAttendanceById = async (data) => {
  try {
    const result = await Request.post(Routes.GETMEMBERATTENDANCEBYID, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const GreetingDelete = async (g_id) => {
  try {
    const result = await Request.get(Routes.GREETINGDELETE + "/" + g_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const ResendGreeting = async (g_id) => {
  try {
    const result = await Request.get(Routes.RESENDGREETING + "/" + g_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getChapterByCity = async (city_id) => {
  try {
    const result = await Request.get(Routes.GETCHAPTERBYCITY + "/" + city_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const insertcityambassador = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTCITYAMBASSODAR, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getCityAmbassadorById = async (member_id) => {
  try {
    const result = await Request.get(Routes.GETCITYAMBASSADORBYID + "/" + member_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const GetActiveMemberByChpt = async (id) => {
  try {
    const result = await Request.get(Routes.GETACTIVEMEMBERBYCHPT + "/" + id);
    return result.data.data;
  } catch (error) {
    throw error;
  }
};

const updateCityAmbssadorDetails = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATECITYAMBSSADORDEATILS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertStaff = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTSTAFF, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const GetStaffByPid = async (id, u_type) => {
  try {
    const result = await Request.get(Routes.GETSTAFFBYPID + "/" + id + "/" + u_type);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateStaffStatus = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATESTAFFSTATUS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deleteStaff = async (data) => {
  try {
    const result = await Request.post(Routes.DELETESTAFF, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateStaffDetails = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATESTAFFDETAILS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getAllocateListById = async (u_id, u_type) => {
  try {
    const result = await Request.get(Routes.GETALLOCATELISTBYID + "/" + u_id + "/" + u_type);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getStaffById = async (u_id, u_type) => {
  try {
    const result = await Request.get(Routes.GETSTAFFBYPID + "/" + u_id + "/" + u_type);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const insertLead = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTLEAD, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertTask = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTTASK, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};
const updatetaskstatus = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATETASKSTATUS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateleadstatus = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATELEADSTATUS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getTaskList = async (u_id, u_type) => {
  try {
    const result = await Request.get(Routes.GETTASKLIST + "/" + u_id + "/" + u_type);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getLeadList = async (u_id, u_type) => {
  try {
    const result = await Request.get(Routes.GETLEADLIST + "/" + u_id + "/" + u_type);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getTaskByTid = async (t_id) => {
  try {
    const result = await Request.get(Routes.GETTASKBYTID + "/" + t_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const updatetaskdetails = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATETASKDETAILS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deleteTask = async (t_id) => {
  try {
    const result = await Request.get(Routes.DELETETASK + "/" + t_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};
const updateTaskPrority = async (t_id, t_priority) => {
  try {
    const result = await Request.get(Routes.UPDATETASKPRIORITY + "/" + t_id + "/" + t_priority);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getLeadByLid = async (l_id) => {
  try {
    const result = await Request.get(Routes.GETLEADBYLID + "/" + l_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const updateleaddetails = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATELEADDETAILS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertFollowUp = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTFOLLOWUP, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getLeadHistory = async (l_id) => {
  try {
    const result = await Request.get(Routes.GETLEADHISTORY + "/" + l_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const leadTransferTO = async (data) => {
  try {
    const result = await Request.post(Routes.LEADTRANSFERTO, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const uploadPaymentImage = async (data) => {
  try {
    const result = await Request.post(Routes.UPLOADPAYMENTIMAGE, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getChapterByUser = async (city_id, u_type) => {
  try {
    const result = await Request.get(Routes.GETCHAPTERBYUSER + "/" + city_id + "/" + u_type);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getMeetingByUser = async (city_id, u_type) => {
  try {
    const result = await Request.get(Routes.GETMEETINGBYUSER + "/" + city_id + "/" + u_type);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getMeetingByUserV2 = async (data) => {
  try {
    const result = await Request.post(Routes.GETMEETINGBYUSERV2, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const insertNewcityambassador = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTNEWCITYAMBASSADOR, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getAllCityAmbassador = async (data) => {
  try {
    const result = await Request.post(Routes.GETALLCITYAMABASSADOR, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const deleteCityAmbassador = async (u_id) => {
  try {
    const result = await Request.get(Routes.DELETECITYAMBASSADOR + "/" + u_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const paymentWithdrawal = async (data) => {
  try {
    const result = await Request.post(Routes.PAYMENTWITHDRAWAL, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getRenewalMemberData = async (l_id) => {
  try {
    const result = await Request.get(Routes.GETRENEWALMEMBERDATA + "/" + l_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const memberRenewal = async (data) => {
  try {
    const result = await Request.post(Routes.MEMBERRENEWAL, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateLeadExpiryApi = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATELEADEXPIRY, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const changeCityAmbassador = async (data) => {
  try {
    const result = await Request.post(Routes.CHANGECITYAMBASSADOR, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getDashboardPinCounter = async (city_id) => {
  try {
    if (city_id != undefined) {
      const result = await Request.get(Routes.GETDASHBOARDPINCOUNTER + "/" + city_id);
      return result?.data;
    } else {
      return [];
    }
  } catch (error) {
    throw error;
  }
};

const getDashboardCounter = async (u_id, u_type, city_id) => {
  try {
    if (u_id != undefined || u_type != undefined || city_id != undefined) {
      const result = await Request.get(
        Routes.GETDASHBOARDCOUNTER + "/" + u_id + "/" + u_type + "/" + city_id
      );
      return result?.data;
    } else {
      return [];
    }
  } catch (error) {
    throw error;
  }
};

const getWalletHistoryById = async (c_a_id) => {
  try {
    const result = await Request.get(Routes.GETWALLETHISTORYBYID + "/" + c_a_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getMemberFeeHistory = async (m_id) => {
  try {
    const result = await Request.get(Routes.GETMEMBERFEEHISTORY + "/" + m_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const uploadLvbDocument = async (data) => {
  try {
    const result = await Request.post(Routes.UPLOADLVBDOCUMENT, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getLvbDocument = async (city_id) => {
  try {
    const result = await Request.get(Routes.GETLVBDOCUMENT + "/" + city_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const deleteDocuement = async (d_id) => {
  try {
    const result = await Request.get(Routes.DELETEDOCUEMENT + "/" + d_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const updateCityAmbassadorProfile = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATECITYAMBASSADORPROFILE, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertFolder = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTFOLDER, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getFolderByCityId = async (city_id) => {
  try {
    const result = await Request.get(Routes.GETFOLDERBYCITYID + "/" + city_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getDocumentByFid = async (f_id) => {
  try {
    const result = await Request.get(Routes.GETDOCUMENTBYFID + "/" + f_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const deleteSubFolder = async (f_id) => {
  try {
    const result = await Request.get(Routes.DELETESUBFOLDER + "/" + f_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getV2vByMemberReport = async (ch_id, m_id) => {
  try {
    const result = await Request.get(Routes.V2VREPORTBYMEMBER + "/" + ch_id + "/" + m_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getBusinessByMemberReport = async (ch_id, m_id) => {
  try {
    const result = await Request.get(Routes.BUSINESSREPORTBYMEMBER + "/" + ch_id + "/" + m_id);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getReferenceByMemberReport = async (ch_id, m_id) => {
  try {
    const result = await Request.get(Routes.GETREFERENCEREPORTBYMEMBER + "/" + ch_id + "/" + m_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getVisitorByMemberReport = async (ch_id, m_id) => {
  try {
    const result = await Request.get(Routes.GETVISITORREPORTBYMEMBER + "/" + ch_id + "/" + m_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getAttendanceByMemberReport = async (m_id) => {
  try {
    const result = await Request.get(Routes.GETATTENDANCEREPORT + "/" + m_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getLvbCounterWeb = async (id) => {
  try {
    const result = await Request.get(Routes.GETLVBCOUNTERWEB + "/" + id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getlvbsearchcounter = async (data) => {
  try {
    const result = await Request.post(Routes.GETLVBSEARCHCOUNTER, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getCityCounterWeb = async (id) => {
  try {
    const result = await Request.get(Routes.GETLVBCOUNTERWEB + "/" + id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getcitysearchcounter = async (data) => {
  try {
    const result = await Request.post(Routes.GETCITYSEARCHCOUNTER, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getcitychaptersearchcounter = async (data) => {
  try {
    const result = await Request.post(Routes.GETCITYCHAPTERSEARCHCOUNTER, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getcityambdetailbyid = async (id) => {
  try {
    if (id != undefined) {
      const result = await Request.get(Routes.GETCITYAMBDETAILBYID + "/" + id);
      return result?.data;
    } else {
      return [];
    }
  } catch (error) {
    throw error;
  }
};

const findTopper = async (data) => {
  try {
    const result = await Request.post(Routes.FINDTOPPER, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const findChaptersMemberData = async (data) => {
  try {
    const result = await Request.post(Routes.CHAPTERSMEMBERDATA, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

// PIN MODULES DATE : 19-07-2023
const insertpinBadge = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTPINBADGE, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};
const getPinBadge = async (type) => {
  try {
    const result = await Request.get(Routes.GETPINLIST + "/" + type);
    return result?.data;
  } catch (error) {
    throw error;
  }
};
const updatePinFunction = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEPIN, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};
const assginPinFunction = async (data) => {
  try {
    const result = await Request.post(Routes.ASSIGNPIN, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};
const getPinByMemberId = async (id) => {
  try {
    const result = await Request.get(Routes.GETPINBYMEMBERID + "/" + id);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateMemberVerificationStatus = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEMEMBERVERIFYSTATUS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};
const getMembersDetailedReport = async (data) => {
  try {
    const result = await Request.post(Routes.GETMEMBERSDETAILREPORT, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};
const getMembersSpecificDetailedReport = async (data) => {
  try {
    const result = await Request.post(Routes.GETMEMBERSPECIFICDETAILREPORT, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertBlackListVisitorFunction = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTBLACKLISTVISITOR, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const fetchBlockVisitorList = async (city_id) => {
  try {
    const result = await Request.get(Routes.GETBLOCKVISITORLIST + "/" + city_id);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const fetchLeadDetailsById = async (id) => {
  try {
    const result = await Request.get(Routes.GETLEADDETAILBYID + "/" + id);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateLeadMemberForm = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATELVBLEAD, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const InsertPublicLeadMemberForm = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTPUBLICLEADFORM, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};
const getSuggestionList = async (data) => {
  try {
    const result = await Request.post(Routes.GETSUGGESTIONLIST, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const uploadSuggestionChunkApi = async (data) => {
  try {
    const result = await Request.post(Routes.UPLOADSUGGESTIONCHUNK, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updatePublicLeadFormEditMode = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEPUBLICLEADFORMEDITMODE, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getMemberInductionList = async (data) => {
  try {
    const result = await Request.post(Routes.GETMEMBERINDUCTIONLIST, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const exportMemberSpecificData = async (data) => {
  try {
    const result = await Request.post(Routes.EXPORTMEMBERALLSPECIFICDATA, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};
const exportMemberAllZip = async (data) => {
  try {
    const result = await Request.post(Routes.EXPORTMEMBERALLZIP, data, {
      headers: {
        Accept: "application/zip, application/json",
        "Content-Type": "application/json"
      },
      responseType: "blob"
    });
    return result;
  } catch (error) {
    throw error;
  }
};
const thankYouNoteApprovalData = async (city_id) => {
  try {
    try {
      const result = await Request.get(Routes.THANKYOUNOTEWAITINGLIST + "/" + city_id);
      return result.data;
    } catch (error) {
      throw error;
    }
  } catch (error) { }
};

const approvedThankyouNoteRequest = async (id) => {
  try {
    const result = await Request.get(Routes.APPROVETHANKYOUNOTE + "/" + id);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deleteThankyouNoteRequest = async (id) => {
  try {
    const result = await Request.get(Routes.DELETEUNAPPROVEDTHANKYOUNOTE + "/" + id);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getNewLeadList = async (data) => {
  try {
    const result = await Request.post(Routes.GETNEWLEADLIST, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getNewLeadDataForExport = async (data) => {
  try {
    const result = await Request.post(Routes.GETNEWLEADFOREXPORT, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getPinAssignReport = async (data) => {
  try {
    const result = await Request.post(Routes.PINASSIGNREPORT, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const exportCityChapterReport = async (data) => {
  try {
    const result = await Request.post(Routes.EXPORTCITYCHAPTERREPORT, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};
const deleteVisitorBlockList = async (g_id) => {
  try {
    const result = await Request.get(Routes.DELETEVISITORBLOCKLIST + "/" + g_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getBlockListVisitorListByMobile = async (data) => {
  try {
    const result = await Request.post(Routes.GETVISITORPREVIOUSELIST, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const checkMemberValidation = async (data) => {
  try {
    const result = await Request.post(Routes.CHECKMOBILEVALIDATION, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const chapterReActivation = async (data) => {
  try {
    const result = await Request.post(Routes.CHAPTERREACTIVE, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getChapterActivityLog = async (id) => {
  try {
    const result = await Request.get(Routes.CHAPTERLOGHISTORY + "/" + id);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updatePassword = async (data) => {
  try {
    const result = await Request.post(Routes.CHANGEUSERPASSWORD, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertMembershipFlow = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTMEMBERSHIPFLOW, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};
const updateMembershipFlow = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEMEMBERSHIPFLOW, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const membershipFlowImageDelete = async (m_f_id) => {
  try {
    const result = await Request.get(Routes.MEMBERSHIPFLOWIMAGEDELETE + "/" + m_f_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getMembershipFlowList = async () => {
  try {
    const result = await Request.get(Routes.GETMEMBERSHIPFLOWLIST, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertmagazine = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTMAGAZINE, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getMagazineList = async (city_id, u_type) => {
  try {
    const result = await Request.get(Routes.GETMAGAZINELIST + "/" + city_id + "/" + u_type);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const magazineDelete = async (magazine_id) => {
  try {
    const result = await Request.get(Routes.MAGAZINEDELETE + "/" + magazine_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const updateMagazine = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEMAGAZINE, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertnotification = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTNOTIFICATION, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const batchInsertNotification = async (data) => {
  try {
    const result = await Request.post(Routes.BATCHINSERTNOTIFICATION, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "multipart/form-data"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getNotificationByBatch = async (parent_n_id) => {
  try {
    const result = await Request.get(Routes.GETNOTIFICATIONBYBATCH + "/" + parent_n_id);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getNotificationChildren = async (parent_n_id) => {
  try {
    const result = await Request.get(Routes.GETNOTIFICATIONCHILDREN + "/" + parent_n_id);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateNotification = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATENOTIFICATION, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "multipart/form-data"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deleteNotification = async (n_id) => {
  try {
    const result = await Request.get(Routes.DELETENOTIFICATION + "/" + n_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getAllNotification = async (city_id, u_type, filters = {}) => {
  try {
    const params = new URLSearchParams();
    if (filters.page) params.append("page", filters.page);
    if (filters.limit) params.append("limit", filters.limit);
    if (filters.n_for_type !== undefined && filters.n_for_type !== -1) params.append("n_for_type", filters.n_for_type);
    if (filters.n_type !== undefined && filters.n_type !== -1) params.append("n_type", filters.n_type);
    if (filters.notification_status !== undefined && filters.notification_status !== 0) params.append("notification_status", filters.notification_status);
    if (filters.search) params.append("search", filters.search);
    if (filters.sort_by) params.append("sort_by", filters.sort_by);
    if (filters.sort_order) params.append("sort_order", filters.sort_order);
    const queryString = params.toString();
    const url = Routes.GETALLNOTIFICATION + "/" + city_id + "/" + u_type + (queryString ? "?" + queryString : "");
    const result = await Request.get(url);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getReadNotificationData = async (n_id) => {
  try {
    const result = await Request.get(Routes.GETREADNOTIFICATIONDATA + "/" + n_id);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertTrainingWebinar = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTTRAININGWEBINAR, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateTrainingWebinar = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATETRAININGWEBINAR, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deleteTrainingWebinar = async (n_id) => {
  try {
    const result = await Request.get(Routes.DELETETRAININGWEBINAR + "/" + n_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getAllTrainingWebinar = async (city_id, u_type) => {
  try {
    const result = await Request.get(Routes.GETALLTRAININGWEBINAR + "/" + city_id + "/" + u_type);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertAchievementpinBadge = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTACHIEVEMENTPINBADGE, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getAchievementPinBadge = async () => {
  try {
    const result = await Request.get(Routes.GETACHIEVEMENTPINLIST);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const updateAchievementpinBadge = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEACHIEVEMENTPINBADGE, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertMeetingFeedbackFor = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTMEETINGFEEDBACKFOR, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateMeetingFeedbackFor = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEMEETINGFEEDBACKFOR, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deleteMeetingFeedbackFor = async (m_f_id) => {
  try {
    const result = await Request.get(Routes.DELETEMEETINGFEEDBACKFOR + "/" + m_f_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getMeetingFeedbackForList = async () => {
  try {
    const result = await Request.get(Routes.GETMEETINGFEEDBACKFOR);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const GetMeetingByChptId = async (id) => {
  try {
    const result = await Request.get(Routes.GETMEETINGBYCHPTID + "/" + id);
    return result.data.data;
  } catch (error) {
    throw error;
  }
};

const getMeetingFeedbackReport = async () => {
  try {
    const result = await Request.get(Routes.GETMEETINGFEEDBACKREPORT);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getRenewalFollowupReport = async (data) => {
  try {
    const result = await Request.post(Routes.GETRENEWALFOLLOWUPREPORT, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getDirectorHistoryLog = async (data) => {
  try {
    const result = await Request.post(Routes.GETDIRECTORHISTORYLOG, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const addDirectorHistoryLog = async (data) => {
  try {
    const result = await Request.post(Routes.ADDDIRECTORHISTORYLOG, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const updateDirectorHistoryLog = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEDIRECTORHISTORYLOG, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const searchDirectorHistoryLog = async (data) => {
  try {
    const result = await Request.post(Routes.SEARCHDIRECTORHISTORYLOG, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const deleteDirectorHistoryLog = async (data) => {
  try {
    const result = await Request.post(Routes.DELETEDIRECTORHISTORYLOG, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getChapterDirectors = async (data) => {
  try {
    const result = await Request.post(Routes.GETCHAPTERDIRECTORS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const assignChapterDirectors = async (data) => {
  try {
    const result = await Request.post(Routes.ASSIGNCHAPTERDIRECTORS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getChapterDirectorCandidates = async (data) => {
  try {
    const result = await Request.post(Routes.GETCHAPTERDIRECTORCANDIDATES, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getChapterDirectorLogs = async (data) => {
  try {
    const result = await Request.post(Routes.GETCHAPTERDIRECTORLOGS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getMemberFeedbackAttachment = async (mf_id) => {
  try {
    const result = await Request.get(Routes.GETMEMBERFEEDBACKATTACHMENT + "/" + mf_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getMemberV2VSheetReportData = async (city_id, u_type) => {
  try {
    const result = await Request.get(
      Routes.GETMEMBERV2VSHEETREPORTDATA + "/" + city_id + "/" + u_type
    );
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getMemberV2VSheetData = async (member_id) => {
  try {
    const result = await Request.get(Routes.GETMEMBERV2VSHEETDATA + "/" + member_id);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const downloadV2VSheet = async (member_id) => {
  try {
    const result = await Request.get(Routes.DOWNLOADV2VSHEET + "/" + member_id);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const UpdateDescriptionSetting = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEDESCRIPTIONSETTING, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertAskRejectReason = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTASKREJECTREASON, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateAskRejectReason = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEASKREJECTREASON, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deleteAskRejectReason = async (a_r_reason_id) => {
  try {
    const result = await Request.get(Routes.DELETEASKREJECTREASON + "/" + a_r_reason_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getAskRejectReason = async () => {
  try {
    const result = await Request.get(Routes.GETASKREJECTREASON);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getAsksList = async (city_id, u_type) => {
  try {
    const result = await Request.get(Routes.GETASKSLIST + "/" + city_id + "/" + u_type);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const askApproveReject = async (data) => {
  try {
    const result = await Request.post(Routes.ASKAPPROVEREJECT, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateSuggestionAnswer = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATESUGGESTIONANSWER, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deleteSuggestionAttachmentApi = async (id) => {
  try {
    const result = await Request.delete(Routes.DELETESUGGESTIONATTACHMENT, {
      data: { s_a_id: id }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const insertV2VRejectReason = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTV2VREJECTREASON, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateV2VRejectReason = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEV2VREJECTREASON, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deleteV2VRejectReason = async (v2v_r_id) => {
  try {
    const result = await Request.get(Routes.DELETEV2VREJECTREASON + "/" + v2v_r_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getV2VRejectReason = async () => {
  try {
    const result = await Request.get(Routes.GETV2VREJECTREASON);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getV2VDataList = async (data) => {
  try {
    const result = await Request.post(Routes.GETV2VDATALIST, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const v2vApproveReject = async (data) => {
  try {
    const result = await Request.post(Routes.V2VAPPROVEREJECT, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertBlueTickRejectReason = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTBLUETICKREJECTREASON, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateBlueTickRejectReason = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEBLUETICKREJECTREASON, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deleteBlueTickRejectReason = async (bluetick_r_id) => {
  try {
    const result = await Request.get(Routes.DELETEBLUETICKREJECTREASON + "/" + bluetick_r_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getBlueTickRejectReason = async () => {
  try {
    const result = await Request.get(Routes.GETBLUETICKREJECTREASON);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getBlueTickApplyList = async (city_id, u_type) => {
  try {
    const result = await Request.get(Routes.GETBLUETICKAPPLYLIST + "/" + city_id + "/" + u_type);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const blueTickApproveReject = async (data) => {
  try {
    const result = await Request.post(Routes.BLUETICKAPPROVEREJECT, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertMgt = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTMGT, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateMgt = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEMGT, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deletetMgt = async (mgt_id) => {
  try {
    const result = await Request.get(Routes.DELETETMGT + "/" + mgt_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getAllMgtList = async (city_id, u_type) => {
  try {
    const result = await Request.get(Routes.GETALLMGTLIST + "/" + city_id + "/" + u_type);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertMgtQuestions = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTMGTQUESTIONS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateMgtQuestions = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEMGTQUESTIONS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deleteMgtQuestions = async (mgt_que_id) => {
  try {
    const result = await Request.get(Routes.DELETEMGTQUESTIONS + "/" + mgt_que_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getMgtQuestions = async () => {
  try {
    const result = await Request.get(Routes.GETMGTQUESTIONS);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getBlueTickQuestionAnswer = async (mf_id) => {
  try {
    const result = await Request.get(Routes.GETBLUETICKQUESTIONANSWER + "/" + mf_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const insertMemberLeadRejectReason = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTMEMBERLEADREJECTREASON, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getFollowupLeadList = async (data) => {
  try {
    const result = await Request.post(Routes.GETFOLLOWUPLEADLIST, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertLeadRejectReason = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTLEADREJECTREASON, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateLeadRejectReason = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATELEADREJECTREASON, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deleteLeadRejectReason = async (m_f_id) => {
  try {
    const result = await Request.get(Routes.DELETELEADREJECTREASON + "/" + m_f_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getLeadRejectReason = async () => {
  try {
    const result = await Request.get(Routes.GETLEADREJECTREASON);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const insertOBTRejectReason = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTOBTREJECTREASON, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateOBTRejectReason = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEOBTREJECTREASON, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deleteOBTRejectReason = async (obt_r_id) => {
  try {
    const result = await Request.get(Routes.DELETEOBTREJECTREASON + "/" + obt_r_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getOBTRejectReason = async () => {
  try {
    const result = await Request.get(Routes.GETOBTREJECTREASON);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const insertOBTQuestions = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTOBTQUESTIONS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateOBTQuestions = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEOBTQUESTIONS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deleteOBTQuestions = async (obt_que_id) => {
  try {
    const result = await Request.get(Routes.DELETEOBTQUESTIONS + "/" + obt_que_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getOBTQuestions = async () => {
  try {
    const result = await Request.get(Routes.GETOBTQUESTIONS);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const insertOBT = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTOBT, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateOBT = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEOBT, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deletetOBT = async (obt_id) => {
  try {
    const result = await Request.get(Routes.DELETEOBT + "/" + obt_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getAllOBTlist = async (city_id, u_type) => {
  try {
    const result = await Request.get(Routes.GETALLOBTLIST + "/" + city_id + "/" + u_type);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getOBTApplyList = async (city_id, u_type) => {
  try {
    const result = await Request.get(Routes.GETOBTAPPLYLIST + "/" + city_id + "/" + u_type);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getOBTQuestionAnswer = async (obt_apply_id) => {
  try {
    const result = await Request.get(Routes.GETOBTQUESTIONANSWER + "/" + obt_apply_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const obtApproveReject = async (data) => {
  try {
    const result = await Request.post(Routes.OBTAPPROVEREJECT, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertMemberDeactiveReason = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTMEMBERDEACTIVEREASON, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateMemberDeactiveReason = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEMEMBERDEACTIVEREASON, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deleteMemberDeactiveReason = async (obt_que_id) => {
  try {
    const result = await Request.get(Routes.DELETEMEMBERDEACTIVEREASON + "/" + obt_que_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getMemberDeactiveReason = async () => {
  try {
    const result = await Request.get(Routes.GETMEMBERDEACTIVEREASON);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const sendOtpToMobile = async (data) => {
  try {
    const result = await Request.post(Routes.SENDOTPTOMOBILE, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};
const getMemberConnectedandBlockList = async (data) => {
  try {
    const result = await Request.post(Routes.GETMEMBERCONNECTEDANDBLOCKLIST, data);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const updateConnectionRequestMailStatus = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATECONNECTIONREQUESTMAILSTATUS, data);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const CheckMobileNumberExist = async (data) => {
  try {
    const result = await Request.post(Routes.CHECKMOBILENUMBEREXIST, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateEditModeInMemberRenewalLead = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEEDITMODEINMEMBERRENEWALLEAD, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const addUpdatePageInstructionApi = async (data) => {
  try {
    const result = await Request.post(Routes.ADDUPDATEPAGEINSTRUCTION, data);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const addBlockMemberApi = async (data) => {
  try {
    const result = await Request.post(Routes.ADDMEMBERTOBLOCK, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const fetchBlockMemberList = async (user_id) => {
  try {
    const result = await Request.get(Routes.GETBLOCKMEMBERLIST + "/" + user_id);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getPageInstructionApi = async () => {
  try {
    const result = await Request.get(Routes.GETPAGEINSTRUCTION);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const deleteBlockMemberList = async (data) => {
  try {
    const result = await Request.post(Routes.REMOVEMEMBERFROMBLOCK, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const verifyGSTNumber = async (data) => {
  try {
    const result = await Request.post(Routes.VERIFYGSTNUMBER, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertProduct = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTPRODUCT, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getProducts = async (data) => {
  try {
    const result = await Request.post(Routes.GETPRODUCT, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateProduct = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEPRODUCT, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateProductStatus = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEPRODUCTSTATUS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const stockOutSendType = async (data) => {
  try {
    const result = await Request.post(Routes.STOCKOUTSENDTYPE, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const stockInsertData = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTSTOCKINDATA, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const assignStockToCityData = async (data) => {
  try {
    const result = await Request.post(Routes.ASSIGNSTOCKTOCITY, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getStockHistoryData = async (data) => {
  try {
    const result = await Request.post(Routes.GETSTOCKHISTORY, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getWelcomekitMemberListData = async (data) => {
  try {
    const result = await Request.post(Routes.GETWELCOMEKITMEMBERLIST, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getPinMemberListData = async (data) => {
  try {
    const result = await Request.post(Routes.GETPINMEMBERLIST, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const assignproductToMemberApi = async (data) => {
  try {
    const result = await Request.post(Routes.ASSIGNPRODUCTTOMEMBER, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateProductStatusApi = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATESTOCKSTATUS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const returnProductToLVBApi = async (data) => {
  try {
    const result = await Request.post(Routes.RETURNPRODUCTTOLVB, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const reAssignProductToMemberApi = async (data) => {
  try {
    const result = await Request.post(Routes.REASSIGNPRODUCTTOMEMBER, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertTravelingTypeApi = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTTRAVELLINGTYPE, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getCityWiseWalletList = async (data) => {
  try {
    const result = await Request.post(Routes.GETCITYWISEWALLETLIST, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getTravelingTypeApi = async () => {
  try {
    const result = await Request.get(Routes.GETTRAVELLINGTYPELIST);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const updateTravelingTypeApi = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATETRAVELLINGTYPE, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const captureCityStockAmountApi = async (data) => {
  try {
    const result = await Request.post(Routes.CAPTURECITYSTOCKAMOUNT, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};
const getAllMemberTravelingListApi = async (data) => {
  try {
    const result = await Request.post(Routes.GETALLMEMBERTRAVELLINGLIST, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getWalletHistoryApi = async (data) => {
  try {
    const result = await Request.post(Routes.GETWALLETHISTORY, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getMemberAllAssignDataApi = async (data) => {
  try {
    const result = await Request.post(Routes.GETMEMBERALLASSIGNDATA, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertReturnStockDataApi = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTSTOCKRETURNENTRY, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateReturnStockStatusApi = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATESTOCKRETURNSTATUS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateStockInDataApi = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATESTOCKINDATA, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const payStockAmountApi = async (data) => {
  try {
    const result = await Request.post(Routes.PAYSTOCKAMOUNT, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getPendingPayoutEntriesApi = async (data) => {
  try {
    const result = await Request.post(Routes.GETPENDINGPAYOUTENTRIES, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const disableMemberEligibiltyApi = async (data) => {
  try {
    const result = await Request.post(Routes.DISABLEMEMBERELIGIBILITY, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getPinReportByMemberApi = async (data) => {
  try {
    const result = await Request.post(Routes.GETPINREPORTBYMEMBER, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const gettPendingmemberVisitorApi = async (member_id) => {
  try {
    const result = await Request.get(Routes.GETPENDINGMEETINGVISITOR + "/" + member_id);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getStockReportCitylist = async () => {
  try {
    const result = await Request.get(Routes.GETSTOCKREPORTCITY);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const readMemberFeedbackApi = async (data) => {
  try {
    const result = await Request.post(Routes.READMEMBERFEEDBACK, data);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getApplicationRouteApi = async (data) => {
  try {
    const result = await Request.post(Routes.GETAPPLICATIONROUTE, data);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const addUpdateApplicationRouteApi = async (data) => {
  try {
    const result = await Request.post(Routes.ADDUPDATEAPPLICATIONROUTE, data, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getAttributeListApi = async () => {
  try {
    const result = await Request.get(Routes.GETATTRIBUTE);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateAttributeApi = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEATTRIBUTE, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertLvbRecordsDynamic = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTLVBRECORDS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateLvbRecordsDynamic = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATELVBRECORDS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getLvbRecordsDynamic = async () => {
  try {
    const result = await Request.get(Routes.GETLVBRECORDS);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getMemberVerificationHistoryApi = async (id) => {
  try {
    const result = await Request.get(Routes.GETMEMBERHISTORY + "/" + id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const deleteLeadAttachment = async (data) => {
  try {
    const result = await Request.post(Routes.DELETELEADATTACHMENT, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });

    return result.data;
  } catch (error) {
    throw error;
  }
};

const GetMemberProfileById = async (id) => {
  try {
    const result = await Request.post(Routes.GETMEMBERPROFILEWEB, {
      m_id: id
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getMemberInductionDataApi = async (id) => {
  try {
    const result = await Request.post(Routes.GETMEMBERINDUCTIONDATA, {
      m_id: id
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const validatecityformlink = async (data) => {
  try {
    const result = await Request.post(Routes.VALIDATECITYFORMLINK, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getPendingStockOverview = async (data) => {
  try {
    const result = await Request.post(Routes.GETPENDINGSTOCKOVERVIEW, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getPendingStockFilterOptions = async () => {
  try {
    const result = await Request.get(Routes.GETPENDINGSTOCKFILTERS);
    return result.data;
  } catch (error) {
    throw error;
  }
};

// Panel auto-refresh: polled by AutoRefreshManager on a timer, so it must never
// reject - a thrown error here would surface as an unhandled rejection in setInterval
// and could trip the axios 401 interceptor into a forced logout.
const getPanelRefreshSchedule = async () => {
  try {
    const result = await Request.get(Routes.GETPANELREFRESHSCHEDULE);
    return result?.data;
  } catch (error) {
    return null;
  }
};

const getChapterListWithCoordinators = async (data) => {
  try {
    const result = await Request.post(Routes.GETCHAPTERLISTWITHCOORDINATORS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

export {
  insertmember,
  getState,
  getCity,
  GetAllUserApi,
  GetAllMemberApi,
  getPrivilegeActiveMemberList,
  GetMemberById,
  UpdateMember,
  getPollSelect,
  insertpoll,
  batchInsertPoll,
  getPollByBatch,
  getPollChildren,
  updatePoll,
  insertevent,
  insertgallery,
  getAllGallery,
  deleteGallery,
  getAllPoll,
  deletePoll,
  getAllEventAnnou,
  EventAnnouDelete,
  UpdateMemberStatus,
  userLogout,
  GetMemberByChptId,
  UpdateMemberPost,
  getpollresult,
  getAllCity,
  getAllState,
  getAllCountry,
  insertcity,
  insertcountry,
  insertlandmark,
  insertmeeting,
  InsertState,
  getAllLandmark,
  UpdateLandmarkStatus,
  UpdateStateStatus,
  UpdateCityStatus,
  GetMeetingById,
  UpdateMeeting,
  getAllChapter,
  getAllBusiness,
  getAllBusinessV1,
  UpdateBamount,
  deleteBusiness,
  getAllV2v,
  getV2vV1,
  deleteV2v,
  getAllReference,
  getAllReferenceV1,
  deleteReference,
  deleteChapter,
  resetMeetingMember,
  GetStateById,
  updateState,
  updatecity,
  updatelandmark,
  deleteMeeting,
  getattendance,
  updateEventAnnouncement,
  getMemberAttendanceByChepter,
  getMemberAttendanceById,
  insertgreeting,
  getAllGreeting,
  GreetingDelete,
  ResendGreeting,
  getChapterByCity,
  insertcityambassador,
  getCityAmbassadorById,
  GetActiveMemberByChpt,
  updateCityAmbssadorDetails,
  insertStaff,
  GetStaffByPid,
  updateStaffStatus,
  deleteStaff,
  updateStaffDetails,
  getAllocateListById,
  insertLead,
  // Jil
  getStaffById,
  insertTask,
  getTaskList,
  getLeadList,
  updatetaskstatus,
  updateleadstatus,
  getTaskByTid,
  updatetaskdetails,
  deleteTask,
  updateTaskPrority,
  getLeadByLid,
  updateleaddetails,
  insertFollowUp,
  getLeadHistory,
  leadTransferTO,
  uploadPaymentImage,
  getChapterByUser,
  getMeetingByUser,
  getMeetingByUserV2,
  insertNewcityambassador,
  getAllCityAmbassador,
  deleteCityAmbassador,
  paymentWithdrawal,
  getRenewalMemberData,
  memberRenewal,
  updateLeadExpiryApi,
  changeCityAmbassador,
  getDashboardCounter,
  getDashboardPinCounter,
  getWalletHistoryById,
  getMemberFeeHistory,
  uploadLvbDocument,
  getLvbDocument,
  deleteDocuement,
  updateCityAmbassadorProfile,
  insertFolder,
  getFolderByCityId,
  getDocumentByFid,
  deleteSubFolder,
  getAllvisitor,
  getAllvisitorV1,
  deleteVisitorData,
  getAllTestimonial,
  getAllTestimonialV1,
  deleteTestimonialData,
  getV2vByMemberReport,
  getBusinessByMemberReport,
  getReferenceByMemberReport,
  getVisitorByMemberReport,
  getAttendanceByMemberReport,
  getLvbCounterWeb,
  getlvbsearchcounter,
  getcitysearchcounter,
  GetMemberProfileById,
  getcitychaptersearchcounter,
  getcityambdetailbyid,
  findTopper,
  findChaptersMemberData,
  insertpinBadge,
  getPinBadge,
  updatePinFunction,
  assginPinFunction,
  getPinByMemberId,
  updateMemberVerificationStatus,
  getMembersDetailedReport,
  getMembersSpecificDetailedReport,
  insertBlackListVisitorFunction,
  fetchBlockVisitorList,
  fetchLeadDetailsById,
  updateLeadMemberForm,
  getSuggestionList,
  uploadSuggestionChunkApi,
  updatePublicLeadFormEditMode,
  getMemberInductionList,
  InsertPublicLeadMemberForm,
  exportMemberSpecificData,
  exportMemberAllZip,
  thankYouNoteApprovalData,
  approvedThankyouNoteRequest,
  deleteThankyouNoteRequest,
  getNewLeadList,
  getNewLeadDataForExport,
  getPinAssignReport,
  exportCityChapterReport,
  deleteVisitorBlockList,
  getBlockListVisitorListByMobile,
  checkMemberValidation,
  chapterReActivation,
  getChapterActivityLog,
  updatePassword,
  insertMembershipFlow,
  updateMembershipFlow,
  membershipFlowImageDelete,
  getMembershipFlowList,
  insertmagazine,
  getMagazineList,
  magazineDelete,
  updateMagazine,
  insertnotification,
  batchInsertNotification,
  getNotificationByBatch,
  getNotificationChildren,
  updateNotification,
  deleteNotification,
  getAllNotification,
  getReadNotificationData,
  insertTrainingWebinar,
  updateTrainingWebinar,
  deleteTrainingWebinar,
  getAllTrainingWebinar,
  insertAchievementpinBadge,
  getAchievementPinBadge,
  updateAchievementpinBadge,
  insertMeetingFeedbackFor,
  updateMeetingFeedbackFor,
  deleteMeetingFeedbackFor,
  getMeetingFeedbackForList,
  GetMeetingByChptId,
  getMeetingFeedbackReport,
  getRenewalFollowupReport,
  getDirectorHistoryLog,
  addDirectorHistoryLog,
  updateDirectorHistoryLog,
  deleteDirectorHistoryLog,
  searchDirectorHistoryLog,
  getChapterDirectors,
  assignChapterDirectors,
  getChapterDirectorCandidates,
  getChapterDirectorLogs,
  getMemberFeedbackAttachment,
  getMemberV2VSheetReportData,
  getMemberV2VSheetData,
  downloadV2VSheet,
  UpdateDescriptionSetting,
  insertAskRejectReason,
  updateAskRejectReason,
  deleteAskRejectReason,
  getAskRejectReason,
  getAsksList,
  askApproveReject,
  updateSuggestionAnswer,
  deleteSuggestionAttachmentApi,
  insertV2VRejectReason,
  updateV2VRejectReason,
  deleteV2VRejectReason,
  getV2VRejectReason,
  getV2VDataList,
  v2vApproveReject,
  insertBlueTickRejectReason,
  updateBlueTickRejectReason,
  deleteBlueTickRejectReason,
  getBlueTickRejectReason,
  getBlueTickApplyList,
  blueTickApproveReject,
  insertMgt,
  updateMgt,
  deletetMgt,
  getAllMgtList,
  insertMgtQuestions,
  updateMgtQuestions,
  deleteMgtQuestions,
  getMgtQuestions,
  getBlueTickQuestionAnswer,
  insertMemberLeadRejectReason,
  getFollowupLeadList,
  insertLeadRejectReason,
  updateLeadRejectReason,
  deleteLeadRejectReason,
  getLeadRejectReason,
  insertOBTRejectReason,
  updateOBTRejectReason,
  deleteOBTRejectReason,
  getOBTRejectReason,
  insertOBTQuestions,
  updateOBTQuestions,
  deleteOBTQuestions,
  getOBTQuestions,
  insertOBT,
  updateOBT,
  deletetOBT,
  getAllOBTlist,
  getOBTApplyList,
  getOBTQuestionAnswer,
  obtApproveReject,
  insertMemberDeactiveReason,
  updateMemberDeactiveReason,
  deleteMemberDeactiveReason,
  getMemberDeactiveReason,
  sendOtpToMobile,
  CheckMobileNumberExist,
  updateEditModeInMemberRenewalLead,
  getMemberConnectedandBlockList,
  updateConnectionRequestMailStatus,
  addUpdatePageInstructionApi,
  getPageInstructionApi,
  addBlockMemberApi,
  fetchBlockMemberList,
  deleteBlockMemberList,
  verifyGSTNumber,
  getStockProductList,
  insertProduct,
  getProducts,
  updateProduct,
  updateProductStatus,
  stockOutSendType,
  stockInsertData,
  assignStockToCityData,
  getStockHistoryData,
  getWelcomekitMemberListData,
  getPinMemberListData,
  getPinReportByMemberApi,
  assignproductToMemberApi,
  updateProductStatusApi,
  returnProductToLVBApi,
  reAssignProductToMemberApi,
  getCityWiseWalletList,
  captureCityStockAmountApi,
  getWalletHistoryApi,
  getMemberAllAssignDataApi,
  insertReturnStockDataApi,
  updateReturnStockStatusApi,
  updateStockInDataApi,
  payStockAmountApi,
  getPendingPayoutEntriesApi,
  insertTravelingTypeApi,
  getTravelingTypeApi,
  updateTravelingTypeApi,
  getAllMemberTravelingListApi,
  disableMemberEligibiltyApi,
  gettPendingmemberVisitorApi,
  getStockReportCitylist,
  readMemberFeedbackApi,
  getApplicationRouteApi,
  addUpdateApplicationRouteApi,
  getAttributeListApi,
  updateAttributeApi,
  insertLvbRecordsDynamic,
  updateLvbRecordsDynamic,
  getLvbRecordsDynamic,
  getMemberVerificationHistoryApi,
  deleteLeadAttachment,
  getMemberInductionDataApi,
  validatecityformlink,
  getPendingStockOverview,
  getPendingStockFilterOptions,
  getChapterListWithCoordinators,
  getAchievementPinsWithProgress,
  getSystemLogModules,
  getSystemLogs,
  getCitySupportList,
  createCitySupportProfile,
  updateCitySupportProfile,
  deleteCitySupportProfile,
  updateCitySupportProfileStatus,
  getCityEdDetails,
  saveCityEdDetails,
  getPanelRefreshSchedule
};
